module.exports = __webpack_public_path__ + "static/media/palmtree-1.09154e5b.png";